import get from 'lodash.get';
import querystring from 'querystring';

const qsMap = querystring.parse(window.location.search.slice(1));

const experienceOverrides = qsMap.exp
    ? []
          .concat(qsMap.exp)
          .map((p) => p.split(','))
          .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {})
    : {};

const defaultOptions = {
    atProperty: '',
    targetTimeout: 2000, // after 2s we stop checking for adobe target
    pollInterval: 100 // we check every 100ms
};

const config = defaultOptions;

export const configure = (overrides) => {
    if (!['undefined', 'string'].includes(typeof overrides.atProperty)) {
        throw new TypeError(
            'atProperty must be a string token (visit https://bit.ly/2YwwFQj for more info)'
        );
    }

    if (!['undefined', 'number'].includes(typeof overrides.targetTimeout)) {
        throw new TypeError(
            'targetTimeout must be a number (ms) at which we stop polling for adobe target.'
        );
    }

    if (!['undefined', 'number'].includes(typeof overrides.pollInterval)) {
        throw new TypeError(
            'pollInterval must be a number (ms) that represents the interval at which we poll for adobe target'
        );
    }

    Object.assign(config, overrides);
};

const pollingStarted = Date.now();

const pollForTarget = async () => {
    if (global.adobe && global.adobe.target) {
        return global.adobe.target;
    }

    const delta = Date.now() - pollingStarted;
    if (delta >= config.targetTimeout) {
        throw new Error(
            'timed out waiting for adobe.target to become available'
        );
    }

    // delay before recursively calling itself
    await new Promise((res) => setTimeout(res, config.pollInterval));
    return pollForTarget();
};

let targetAvailablePromise;

const getExperience = async (
    mbox,
    defaultExperience,
    at_property = config.atProperty
) => {
    try {
        if (experienceOverrides[mbox]) {
            return experienceOverrides[mbox];
        }

        if (!targetAvailablePromise) {
            targetAvailablePromise = pollForTarget();
        }
        await targetAvailablePromise;

        const offers = await new Promise((res, rej) =>
            window.adobe.target.getOffer({
                mbox,
                params: { at_property },
                success: res,
                error: rej
            })
        );

        const experience = get(offers, '[0].content[0].experience');

        if (!experience) {
            throw new Error(`No experience recieved by adobe for mbox=${mbox}`);
        }

        return experience;
    } catch (err) {
        // eslint-disable-next-line no-console
        console.error(
            `ATarget: error occured getting experience for mbox: ${mbox} falling back to experience: ${defaultExperience}`,
            err
        );

        // default to showing the defaultExperience
        return defaultExperience;
    }
};

export default getExperience;
